<template>
  <div class="guide-main">
    <sidebar-left></sidebar-left>
    <router-view></router-view>
  </div>
</template>

<script>
import SidebarLeft from './Sidebar'
export default {
  components: {
    'sidebar-left': SidebarLeft
  }
}
</script>

<style lang="sass">
  .guide-main
    background-color: #f8f8f8
    min-height: 600px
</style>
